module.exports = __webpack_public_path__ + "static/media/docs (2).0be356e8.webp";